/*
 * @Author: jyy 
 * @Date: 2024-12-24 15:01:59 
 * @Last Modified by: jyy
 * @Last Modified time: 2025-01-10 16:44:56
 */
<template>
    <div class="scenic-card" @click="jumpNewDetail">
        <div class="left">
            <img class="scenic-img" :src="item.img" alt="">
        </div>
        <div class="right">
            <div class="scenic-name">{{ item.scenicSpotName || "" }}</div>
            <div class="scenic-desc" v-if="item.description">{{ item.description.trim() }}</div>
            <div class="scenic-tags">
                <div class="tag" v-for="(tag,i) in item.tags" :key="i" :style="{color:tag.colour,borderColor:tag.boardColour,...(tag.bkcolour?{backgroundColor:tag.bkcolour}:{})}">{{ tag.name  }}</div>
            </div>
            <div class="scenic-price">
                <div class="oldprice" v-if="item.oriPrice">¥{{ item.oriPrice }}</div>
                <div class="saleprice"><span class="price-symbol">¥</span>{{ item.salePrice || "0" }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    created() { },
    mounted() { },
    methods: {
        jumpNewDetail() {
            this.$emit("click", this.item);
        }
    }
}
</script>

<style lang='scss' scoped>
@import '@/scss/_vars.scss';

.scenic-card {
    width: 100%;
    background-color: #ffffff;
    border-radius: 12 * $px;
    padding: 8 * $px;
    box-sizing: border-box;
    display: flex;
    
    .left {
        margin-right: 8 * $px;

        .scenic-img {
            width: 85 * $px;
            height: 110 * $px;
            border-radius: 6.8 * $px;
            object-fit: cover;
        }
    }

    .right {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding-top: 2 * $px;
        .scenic-name {
            font-size: 15 * $px;
            color: #101010;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 设置最大行数为2 */
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .scenic-desc {
            font-size: 12 * $px;
            color: #575757;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 12 * $px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 6 * $px;
        }

        .scenic-tags {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 6 * $px;

            .tag {
                padding: 0 4.5 * $px;
                height: 16 * $px;
                border: 0.5 * $px solid;
                border-color: rgba(50, 99, 166, 0.3);
                border-radius: 4 * $px;
                font-size: 11 * $px;
                color: #305479;
                text-align: center;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                line-height: 16 * $px;
                margin-right: 4 * $px;
                box-sizing: border-box;
            }
        }

        .scenic-price {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            margin-top: auto;
            .oldprice {
                font-size: 13 * $px;
                color: #878787;
                text-decoration: line-through;
                margin-right: 4 * $px;
            }
            .saleprice {
                font-size: 22 * $px;
                color: #FF6347;
                font-weight: 600;
                line-height: 22 * $px;

                .price-symbol {
                    font-size: 13 * $px;
                    color: #FF6347;
                    font-weight: 500;
                    line-height: 13 * $px;
                    margin-right: 2 * $px;
                }
            }
        }
    }
}
</style>